module.exports = __webpack_public_path__ + "static/media/v12.21bff7fc.mp4";